import { useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FolderPlus, Layers } from 'lucide-react';
import { X } from 'lucide-react';
import { useSession } from '@/hooks/useSession';
import { useAppSelector } from '@/store/hooks';
import NewItemModal from '../../components/modals/newItemModal/NewItemModal';

export default function WelcomePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const history = { push: (path: string) => navigate(path) };
  const { updateIsQuerying, workspacePeopleList } = useSession();
  const currentUserGroup = useAppSelector((state) => state.workspace.currentUserGroup);
  const currentUserInfo = useAppSelector((state) => state.user.oldUserDetails);

  const [modalOpen, setModalOpen] = useState<string | undefined>();
  const modalRef = useRef<HTMLDivElement>(null);

  const currentUser = workspacePeopleList?.find(
    (item) =>
      currentUserInfo &&
      ((item as Record<string, unknown>).user as Record<string, string>)?.S ===
        ((currentUserInfo as Record<string, unknown>).user as Record<string, string>)?.S,
  );
  const role = ((currentUser as Record<string, unknown>)?.role as Record<string, string>)?.S;
  const isProOrAdmin = role === 'admin' || role === 'pro';

  function handleOverlayClick(e: React.MouseEvent) {
    if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
      setModalOpen(undefined);
    }
  }

  return (
    <>
      <div className="flex items-center justify-center gap-8 py-20">
        <button
          onClick={() => setModalOpen('newFolder')}
          className="flex w-64 flex-col items-center gap-4 rounded-xl border border-border p-8 transition-colors hover:border-primary hover:bg-primary-muted"
        >
          <h4 className="text-lg font-semibold">Create your first folder</h4>
          <p className="text-sm text-muted-foreground">Create a folder to store all your digital stuff.</p>
          <FolderPlus className="h-20 w-20 text-primary" />
        </button>

        {isProOrAdmin && (
          <button
            onClick={() => setModalOpen('newProject')}
            className="flex w-64 flex-col items-center gap-4 rounded-xl border border-border p-8 transition-colors hover:border-primary hover:bg-primary-muted"
          >
            <h4 className="text-lg font-semibold">Create your first project</h4>
            <p className="text-sm text-muted-foreground">
              Create a project and start working together with people.
            </p>
            <Layers className="h-20 w-20 text-primary" />
          </button>
        )}
      </div>

      {modalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-overlay"
          onClick={handleOverlayClick}
        >
          <div ref={modalRef} className="relative rounded-2xl border border-border/60 bg-card p-6 shadow-2xl">
            <button
              onClick={() => setModalOpen(undefined)}
              className="absolute right-3 top-3 rounded p-1 hover:bg-secondary"
            >
              <X className="h-5 w-5" />
            </button>
            <NewItemModal
              closeModal={() => setModalOpen(undefined)}
              currentUserGroup={currentUserGroup}
              history={history}
              updateIsQuerying={updateIsQuerying}
              location={location}
              currentUserInfo={currentUserInfo}
              welcomeScreenSelection={modalOpen === 'newProject' ? 'project' : 'folder'}
              refreshList={() => {}}
            />
          </div>
        </div>
      )}
    </>
  );
}
